<template>
  <b-overlay :show="loading">
    <div
      data-cy="file"
      :class="{ selected: bidder.adjudicatarioId === selectedBidder }"
      class="row p-3 mt-2 shadow-sm bg-white"
    >
      <div class="col-11">
        <div class="row">
          <div
            class="col-2"
            data-cy="file-number"
          >
           {{bidder.rut}}
          </div>
          <div class="col-9">
            <div class="row">
              <div class="col-4">
                {{bidder.nombre}}
              </div>
              <div class="col-5">
                {{bidder.giro}}
                <br>
              </div>
              <div class="col-3">
                {{bidder.direccion}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-11 offset-1">
            <vs-chip
              class="mr-4"
              color="#7d84ad"
              v-tooltip="'Correo'"
            >
              <vs-avatar icon="email" />
              {{bidder.correo}}
            </vs-chip>
            <vs-chip
              color="#ff9800"
              class="mr-4"
              v-tooltip="'Contacto'"
              v-if="bidder.telefono"
            >
              <vs-avatar icon="person" />
              {{bidder.telefono}}
            </vs-chip>
            <vs-chip
              data-cy="file-status"
              :color="biddersStates[bidder.estadoActivo].color"
              v-if="biddersStates[bidder.estadoActivo]"
              v-tooltip="'Estado Adjudicatario'"
            >
              {{biddersStates[bidder.estadoActivo].label}}
            </vs-chip>
          </div>
        </div>
      </div>
      <div class="col-1 d-flex justify-center">
        <slot name="actions" v-bind:bidder="bidder">
          <SuccessfulBiddersOptions
            :ref="'file-options-' + bidder.adjudicatarioId"
            :bidder="bidder"
            :select-bidder="selectBidder"
            @reload="reloadList"
            v-on:bidder-save="handleBidderSave"
          />
        </slot>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import SuccessfulBiddersOptions from '@/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersOptions';
import { biddersStates } from '@/febos/aduanas/successfulBidder/views/utils/constans';

export default {
  components: { SuccessfulBiddersOptions },
  mixins: [CopyToClipboard],
  data() {
    return {
      loading: false,
      biddersStates
    };
  },
  props: [
    'bidder',
    'selectBidder',
    'reloadList'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('successfulBidders', ['selectedBidder'])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    handleBidderSave(bidder) {
      this.$emit('bidder-save', bidder);
    }
  }
};

</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
.mother-indicator{
  width:160px;
  margin-left:50%;
  left: 80px;
}
</style>
